<template>
  <div>
    <h2>DT Grid</h2>
    <div class="custom-grid-demo-container">
      <div class="dt-custom-grid">
        <!-- <GridTab>
            <GridBox v-if="lazyF" height="190" title="Product Setup" >1</GridBox>
            <GridBox v-if="lazyF" height="155" title="Advanced Product Setup">2</GridBox>
            <GridBox height="65" title="Stock Location" style="height: 70px">3</GridBox>
            <GridBox height="230" title="Prices">4</GridBox>
            <GridBox height="155" title="Groups">5</GridBox>
            <GridBox title="Notes" style="grid-row: span 2" >6</GridBox>
            <GridBox title="Accounts" span="2">7</GridBox>
        </GridTab> -->
        <GridLayout>
          <GridTab>
            <div class="dt-grid-row">
              <div class="dt-grid-column">
                <GridBox height="190" title="Product Setup">1</GridBox>
                <GridBox title="Prices" height="140" :selected="true"
                  >4</GridBox
                >
                <GridBox title="Notes" style="">6</GridBox>
              </div>
              <div class="dt-grid-column">
                <GridBox title="Advanced Product Setup">2</GridBox>
                <GridBox v-if="lazyF" title="Stock Location" height="70"
                  >3</GridBox
                >
                <GridBox title="Groups" height="190">5</GridBox>
              </div>
            </div>
            <div class="dt-grid-row">
              <div class="dt-grid-column">
                <GridBox height="190" title="Accounts">7</GridBox>
              </div>
            </div>
          </GridTab>
          <GridTab title="Tracks">
            <div class="dt-grid-row">
              <div class="dt-grid-column">
                <GridBox height="190" title="Tracklisting">7</GridBox>
              </div>
            </div>
            <div class="dt-grid-row">
              <div class="dt-grid-column">
                <GridBox height="190" title="GEMA">7</GridBox>
              </div>
            </div>
          </GridTab>
          <!-- <GridSeparator>7</GridSeparator>
        <GridBox>9</GridBox>
        <GridBox>10</GridBox>
        <GridBox>11</GridBox>
        <GridBox>12</GridBox>
        <GridBox>13</GridBox>
        <GridBox>14</GridBox>
        <GridBox>15</GridBox>
        <GridBox>16</GridBox>
        <GridBox>17</GridBox>
        <GridBox>18</GridBox>
        <GridBox>19</GridBox>
        <GridBox>20</GridBox>
        <GridBox>21</GridBox>
        <GridBox>22</GridBox>
        <GridBox>23</GridBox>
        <GridBox>24</GridBox>
        <GridBox>25</GridBox>
        <GridBox>26</GridBox>
        <GridBox>27</GridBox>
        <GridBox>28</GridBox>
        <GridBox>29</GridBox>
        <GridBox>30</GridBox>
        <GridBox>31</GridBox>
        <GridBox>32</GridBox>
        <GridBox>33</GridBox>
        <GridBox>34</GridBox>
        <GridBox>35</GridBox>
        <GridBox>36</GridBox>
        <GridBox>37</GridBox>
        <GridBox>38</GridBox>
         -->
        </GridLayout>
      </div>
    </div>
  </div>
</template>
<script>
import { createDTGridHost } from "../../dt-plugins/dt-grid/dt-grid.mixin";

export default {
  mixins: [createDTGridHost()],
  mounted() {
    setTimeout(() => {
      console.log({ lazyF: this.lazyF });
      this.lazyF = false;
      console.log({ lazyF: this.lazyF });
    }, 2000);
  },
  data() {
    return {
      lazyF: true,
    };
  },
};
</script>

<style lang="scss">
.custom-grid-demo-container {
  width: 100wh;
  background: #f6f6f6;
}

/* Flex Based Custom Grid */
</style>